import { List, Map } from 'immutable'
import requestStatus from '../../constants/requestStatus'
import actionTypes from '../../actions/actionTypes'
import { returnStateIfNoAction } from '../helpers'
import { sendDataRequested, sendDataSuccess, sendDataError } from '../helpers-request'


const INIT_STATE = Map({
    status: requestStatus.INITIALIZED,
    data: Map(),
    error: Map()
})

function updateDataFrontByKey(state, action) {
    return state.setIn(['data', 'front', action.payload.key], action.payload.value)
}

const localDataReducer = ( state = INIT_STATE, action) => {
    returnStateIfNoAction(action, state)

    switch(action.type){
        case actionTypes.WP_DATA_UPDATE_REQUEST:
            return sendDataRequested(state);
        case actionTypes.WP_DATA_UPDATE_SUCCESS:
            return sendDataSuccess(INIT_STATE);
        case actionTypes.WP_DATA_UPDATE_ERROR:
            return sendDataError(state, action);
        case actionTypes.WP_LOCAL_DATA_FRONT_UPDATE_BY_KEY:
            return updateDataFrontByKey(state, action)
        default:
            return state;
    }
}

export default localDataReducer;
